import { CSSProperties } from 'react'
import { CloudSun, CloudRainHeavy, CloudLightning } from 'react-bootstrap-icons'
import type { WeatherStatus } from '../../types/dtos'

type IconComponent = typeof CloudSun

/** Shared "play delayed" red — used by both the header button and the DELAYED banner. */
export const WEATHER_DELAYED_BG = '#df5a5b'

/** Header-button colour per stage (neutral / yellow / red). */
export const WEATHER_BUTTON_STYLE: Record<WeatherStatus, CSSProperties> = {
  NONE: { color: '#6c757d' },
  WARNING: { color: '#1c1c1c', backgroundColor: '#ffc107' },
  DELAYED: { color: '#f0f2f5', backgroundColor: WEATHER_DELAYED_BG },
}

/** Header-button icon per stage (weather-type icons; the banner uses its own warning icon). */
export const WEATHER_BUTTON_ICON: Record<WeatherStatus, IconComponent> = {
  NONE: CloudSun,
  WARNING: CloudRainHeavy,
  DELAYED: CloudLightning,
}
